import { Modal } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import {
  classifierColumns,
  ClassifierFilters,
  ZClassifier,
} from "src/business/classifier";
import { MdmTable } from "src/components/MdmTable";
import { RtSelection } from "src/components/ReactiveTable/components/RtSelection";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { ToolBox2 } from "src/components/ToolBox2";

type PropsClassifiersAddModal = {
  store: RtStore<ZClassifier, ClassifierFilters> | undefined;
  close(): void;
  onSelect(classifiers: ZClassifier[]): void;
};

export const ClassifiersAddModal: React.FC<PropsClassifiersAddModal> = observer(
  (props) => {
    const { store, close, onSelect } = props;
    return (
      <Modal
        open={!!store}
        onCancel={close}
        title="Выбор классификаторов"
        centered
        okText="Выбрать"
        okButtonProps={{ disabled: !store?.selectedKeys.length }}
        onOk={() => {
          onSelect(store?.selectedRows ?? []);
        }}
        width="90vw"
        styles={{
          body: {
            height: "calc(85vh - 80px)",
          },
        }}
      >
        {store && (
          <ToolBox2
            mainTool={
              <RtSelection
                store={store}
                makeOption={(key, row) => ({
                  value: key,
                  label: row?.name || key,
                })}
              />
            }
          >
            <MdmTable
              store={store}
              columns={classifierColumns}
              resizableColumns
            />
          </ToolBox2>
        )}
      </Modal>
    );
  },
);
